import { CalendarAPI } from "../../api/CalendarAPI";
import { isClubOwner, isClubStaff } from "../../util/UserRoles";

//Create event on database
export const createSchedule = async (data, user, currentGameId, clubId) => {       
   const date = new Date(data?.StartTime);

   const year = date.getFullYear();
   const month = `0${date.getMonth() + 1}`.slice(-2);
   const day = `0${date.getDate()}`.slice(-2);

   const formattedDate = `${year}-${month}-${day}`;

    const reservationData = {
    reservationID: data?.Id,
    reservationName: "blah",
    reservationDate:formattedDate,
    reservationCheckIn: data?.StartTime,
    reservationCheckOut: data?.EndTime,
    isAllDay: data?.IsAllDay,
    recurrenceRule: null,
    userIds: data?.Player,
    resourceId: data?.CourtNumber,
    description: data?.Description,
    reservationCreatedBy: user.userId,
    reservationUpdatedBy: user.userId,
    clubId: clubId,
    gameId: currentGameId,
      isUserAdmin: isClubOwner(user),
    isStaffUser: isClubStaff(user),
    isFree: data?.IsFree
   // recurrenceRule: data?.RecurrenceRule

   }       
    return await CalendarAPI.postSaveReservation(reservationData)


}

//Update schedule in database
export const updateSchedule = async (data, user, currentGameId, clubId) => {


    const date = new Date(data?.StartTime);

    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);

    const formattedDate = `${year}-${month}-${day}`;

    const x =  new Date(data?.StartTime)
    const saveRes = {
      reservationID: data?.Id,
      reservationName: "blah",
      reservationDate: formattedDate,
      reservationCheckIn: data?.StartTime,
      reservationCheckOut: data?.EndTime,
      isAllDay: data?.IsAllDay,
      userIds: data?.Player,
      resourceId: data?.CourtNumber,
      description: data?.Description,
      reservationUpdatedBy: user.userId,
      clubId: clubId,
      gameId: currentGameId,
      isUserAdmin: isClubOwner(user),
      isStaffUser: isClubStaff(user),
      isFree: data?.IsFree
    //  recurrenceRule: data?.RecurrenceRule
    };

    return await CalendarAPI.patchSaveReservation(
      saveRes,
      saveRes.reservationID
    );
}

//Delete schedule from database
export const deleteSchedule = async (reservationId, clubId, status) => {
  return await CalendarAPI.deleteReservation(reservationId, clubId, { status: status });
}